export default __webpack_public_path__ + "static/media/code.cdffb490.svg";